/**
 * Etiqueta del número de abonado de la temporada anterior.
 *
 * Se usa en los flujos de renovación que piden el número con el que se abonó el
 * año pasado. La temporada anterior es siempre (año actual - 1) / año actual, en
 * dos cifras: en 2026 → "nº abonado temporada 25/26".
 *
 * @returns {string}
 */
export function useOldSeasonLabel() {
    const year = new Date().getFullYear();
    const prev = String(year - 1).slice(-2);
    const curr = String(year).slice(-2);

    return `nº abonado temporada ${prev}/${curr}`;
}
